/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PointOfInterestDto } from './pointOfInterestDto';


export interface MaintenanceTimerTreeViewDto { 
    id: string;
    type: MaintenanceTimerTreeViewDto.TypeEnum;
    durationDays: number;
    nextDate: string;
    associatedPointOfInterest?: PointOfInterestDto;
}
export namespace MaintenanceTimerTreeViewDto {
    export type TypeEnum = 'Maintenance' | 'Inspection' | 'SelfInspection' | 'Warranty';
    export const TypeEnum = {
        Maintenance: 'Maintenance' as TypeEnum,
        Inspection: 'Inspection' as TypeEnum,
        SelfInspection: 'SelfInspection' as TypeEnum,
        Warranty: 'Warranty' as TypeEnum
    };
}


